<template lang="pug">
  v-content
    gallery(:images="images" :index="index" @close="index = null" :options="{ closeOnSlideClick: true }")
    v-container(fluid)
      v-row(justify="center")
        v-col(cols=12 sm=6 md=4 xl=4)
          v-card(hover shaped @click="index=0")
            v-img(src="@/assets/aelita.jpg" aspect-ratio=0.7)
        v-col(cols=12 sm=6 md=8 xl=7)
          v-card(shaped)
            v-card-title.headline УСПЕХ ПРЕПОДАВАТЕЛЯ - ЭТО УСПЕХ ЕГО УЧЕНИКОВ
            v-card-text.body-1 Многие великие люди считали, что творчество является неотъемлемой частью жизни
              | человека. Наиболее совершенной сферой прекрасного. Творчество — начало, даюшее
              | человеку бессмертие. Неспособных людей нет. Есть неспособные определить свои
              | способности, развить их. А поскольку эти задачи решаются в детстве, то вина в этом
              | прежде всего родителей. Без их помощи родителей и учителя ребенку эти проблемы не
              | решить. Преподаватель- это помощник и проводник в мир прекрасного. Поэтому это мой
              | сознательный выбор .Помогать детям прикоснуться к знаниям и опыту. При этом каждый
              | ребенок как уникальная жемчужина индивидуален и неповторим. Каждый человек должен
              | избрать тот путь, который наиболее соответствует его природным способностям и
              | наклонностям, найти свое призвание.
              | Вся моя жизнь связала с творчеством, музыкой. Музыка заставляет нас переживать,
              | чувствовать глубоко и ярко. А для каждого человека это важно. Я не могу обойтись без
              | музыки ни дня. Во многом это «профессиональная привычка», ведь с пяти лет я
              | занималась на скрипке, фортепиано, увлекалась вокалом. На уроках я стараюсь
              | поддерживать атмосферу доброжелательности и доверия. А как иначе преподавать?
              | Любить музыку насильно не заставишь, можно только увлечь. И одна я с этой задачей не
              | справлюсь, мне нужна поддержка всего класса. Стараюсь детей увлекать и вести к
              | намеченной цели. Постепенно, шаг за шагом вырабатывать потребность в
              | самостоятельности суждений и оценок, воспринимаемых явлений, пробуждать
              | инициативу и творческую фантазию. Мои ученики - это источник творчества!
          v-row.mt-5
            v-col(cols=12).text-center
              h1.display-1 Награды и дипломы
            v-col(cols=4 v-for="i in 13" :key="i")
              v-card(hover @click="index=i")
                v-img(:src="require(`@/assets/awards/${i}.jpg`)" aspect-ratio=0.7)
</template>


<script>
import VueGallery from 'vue-gallery'

export default {
  name: 'About',
  data() {
    return {
      index: null
    }
  },
  components: {
    gallery: VueGallery
  },
  computed: {
    images() {
      return [
        require(`@/assets/aelita.jpg`),
        ...[...Array(13).keys()].map(i =>
          require(`@/assets/awards/${i + 1}.jpg`)
        )
      ]
    }
  }
}
</script>